
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internet",
      function () {
        return require("private-next-pages/internet/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internet"])
      });
    }
  